import { render, staticRenderFns } from "./ExpertView.vue?vue&type=template&id=66ecabea&scoped=true&"
import script from "./ExpertView.vue?vue&type=script&lang=js&"
export * from "./ExpertView.vue?vue&type=script&lang=js&"
import style0 from "./ExpertView.vue?vue&type=style&index=0&id=66ecabea&lang=scss&scoped=true&"
import style1 from "./ExpertView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ecabea",
  null
  
)

export default component.exports